// extracted by mini-css-extract-plugin
export default {"textarea":"textarea"};